import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import HowItWoks from "./Pages/HowItWoks";
import About from "./Pages/About";
import AllModal from "./Pages/AllModal";
import Contact from "./Pages/Contact";
import Login from "./Pages/User/Login";
import Signup from "./Pages/User/Signup";
import MobileVerification from "./Pages/MobileVerification";
import AboutForm from "./Pages/AboutForm";
import AddPhotos from "./Pages/AddPhotos";
import Profile from "./Pages/Profile";
import Join from "./Pages/Join";
import BasicInfo from "./Pages/BasicInfo";
import Error from "./Pages/Error";
import { ToastContainer } from 'react-toastify';
import ModelDetailPage from "./Pages/ModelDetailPage";
import ForgotPassword from "./Pages/User/ForgotPassword";
import Cookies from "./Pages/Cookies";
import TnC from "./Pages/TnC";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import { useEffect, useState } from "react";
import maintenanceImage from "./Assets/maintenance.png";
import maintenance1 from "./Assets/maintenance1.jpg";
import HostessForgotPassword from "./Pages/Hostess/HostessForgotPassword";

function App() {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch("https://ht-admin.hostessforyou.com/api/maintenance")
      .then(response => response.json())
      .then(data => {
        if (data?.data?.isUnderMaintenance) {
          setIsMaintenance(true);
        }
        setIsLoading(false);
      })
      .catch(error => {
        console.error("Error checking maintenance status:", error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (isMaintenance) {
    return (
      <div className="maintenance-container">
        <img src={maintenance1} alt="Maintenance" className="maintenance-image" />
        <h2 className="maintenance-text">We're Under Maintenance</h2>
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/howitwoks" element={<HowItWoks />} />
          <Route path="/about" element={<About />} />
          <Route path="/allmodal" element={<AllModal />} />
          <Route path="/ModelDetail/:id" element={<ModelDetailPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mobileverification" element={<MobileVerification />} />
          <Route path="/addabout" element={<AboutForm />} />
          <Route path="/addphotos" element={<AddPhotos />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/join" element={<Join />} />
          <Route path="/basicinfo" element={<BasicInfo />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route path="/HostessForgotPassword" element={<HostessForgotPassword />} />
          <Route path="/error" element={<Error />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/tnc" element={<TnC />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />

          <Route path="*" element={<Home />} />
        </Routes>
      </Router>
    </>
  );
}



export default App;
